/**
 * Copyright Mántum All Rights Reserved.
 */
import debug from 'debug';
import {
    useGroup,
    EVENT_CLEAR,
    ACTION_VALUE,
    useGroupDispatch
} from '../../group';

import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from 'react';

import type { Detail } from '@mantum/kanela';

const logger = debug('kanela');
const render = debug('kanela:render');

export type PropTypes = {
    name?: string;
    onChange?: (name?: string, value?: unknown) => void;
    testid?: string;
    value?: string | number;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function Hidden(props, ref) {
        // prettier-ignore
        const {
        name,
        value = ''
    } = props

        const changeRef = useRef(props.onChange);
        const inputRef = useRef<HTMLInputElement>(null);

        const groups = useGroup();
        const dispatch = useGroupDispatch();
        const [currentValue, setCurrentValue] = useState<string | number>('');

        useImperativeHandle(
            ref,
            () => {
                return {
                    name: name,
                    validable: false,
                    clear() {
                        if (name) {
                            dispatch({
                                type: EVENT_CLEAR,
                                content: [
                                    {
                                        action: ACTION_VALUE,
                                        target: name
                                    }
                                ]
                            });
                        }
                    },
                    validate() {
                        return true;
                    },
                    value() {
                        return inputRef.current?.value;
                    }
                };
            },
            [dispatch, name]
        );

        useEffect(() => {
            changeRef.current = props.onChange;
        }, [props.onChange]);

        useEffect(() => {
            setCurrentValue(value);
        }, [value]);

        useEffect(() => {
            if (changeRef.current) {
                changeRef.current(name, value);
            }
        }, [name, value]);

        useEffect(() => {
            if (!name || !groups) {
                return;
            }

            if (!(name in groups)) {
                return;
            }

            const content = groups[name];
            if (content.action === ACTION_VALUE) {
                const value = content.value;
                setCurrentValue(`${value}`);

                logger('receive dispatch change value "%s": %s', name, value);
                if (changeRef.current) {
                    changeRef.current(name, value);
                }
            }
        }, [name, groups]);

        render('[Hidden]: %o', {
            value,
            current: currentValue
        });

        return (
            <input
                className='hidden'
                name={name}
                ref={inputRef}
                type='hidden'
                value={currentValue}
            />
        );
    }
);
